import React from 'react';
import PropTypes from 'prop-types';
import CoachingReviewActions from 'actions/coaching/CoachingReviewActions';
import './PlaylistLiveCoachingHint.styl';
import throttle from 'lodash/throttle';
import classNames from 'classnames';
import UpcomingReviewsActions from 'actions/coaching/UpcomingReviewsActions';
import UPCOMING_REVIEW_ROLES from 'actions/coaching/UPCOMING_REVIEW_ROLES';

export default class PlaylistLiveCoachingHint extends React.PureComponent {
  render() {
    const {review, sessionUser, todo, onAdd} = this.props;

    const hintText =
      review.livecoachingStubs <= 0
        ? 'I will coach a call live during the meeting'
        : 'Add another live coaching call';
    return (
      <div
        className={classNames('playlist-live-coaching-hint pointer', {
          done: todo.callsToAdd === 0,
        })}
        onClick={throttle(
          () =>
            CoachingReviewActions.setLiveCoachingStubs(
              review.id,
              review.livecoachingStubs + 1
            ).then(() => {
              onAdd();
              UpcomingReviewsActions.upcomingReviews(
                sessionUser.id,
                UPCOMING_REVIEW_ROLES.COACH,
                undefined,
                1,
                review.id
              );
            }),
          1000
        )}>
        {hintText}
      </div>
    );
  }
}

PlaylistLiveCoachingHint.propTypes = {
  reviewId: PropTypes.number,
  stubs: PropTypes.number,
};
